import { ILinkCreationRequestParameter } from 'src/views/LinkCreate/types';
import { IGridElement, ISheetHeaders } from '../../types';
import { markInvalidOptions } from './markInvalidOptions';

interface IMarkRowErrors {
  row: IGridElement[];
  headers: ISheetHeaders;
  missingParameterIds: number[];
  invalidParameterIds: number[];
  linkCreationRequestParameters: ILinkCreationRequestParameter[];
}

export const markRowErrors = ({
  row,
  headers,
  missingParameterIds,
  invalidParameterIds,
  linkCreationRequestParameters,
}: IMarkRowErrors) => {
  let firstError = true;
  return row.map((cell, cellIndex) => {
    const parameterId = headers[cellIndex].id;
    const isMissing = missingParameterIds.includes(parameterId);
    let error;
    let options = cell.options || [];

    if (isMissing && !cell.value) {
      firstError = false;
      error = 'Required';
    }
    if (
      firstError &&
      cell.type === 'select' &&
      invalidParameterIds.includes(parameterId)
    ) {
      firstError = false;
      error = 'Value incorrect';
      const validItems = linkCreationRequestParameters[cellIndex].items.map(
        (i) => i.id
      );
      if (validItems.length === 0) {
        error = 'Parameter not applicable for the values chosen so far';
      }
      options = markInvalidOptions(options, validItems);
    }

    return {
      ...cell,
      options,
      error,
    };
  });
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/markRowErrors.ts